import { GetMessage } from '~/shared/components/parts/Message/Message';
import {
  ModalDialogComponent,
  ModalDialogComponentProps,
} from '../ModalDialog/ModalDialog';
import { CaptionButton } from '~/shared/components/ui/Button/CaptionButton';
// import './base.css';
import './EditModeSelectDialog.css';
import { useEffect, useState, ChangeEvent } from 'react';
import { useIntl } from 'react-intl';
import { ErrorMessage } from '~/shared/components/parts/ErrorMessage/ErrorMessage';
import { GetMessageWithIntl } from '../../parts/Message/Message';

export interface EditModeSelectOutputDialogProps {
  isOpen: boolean;
  onAIEditDecision: () => void;
  onStandardEditDecision: () => void;
  onCancel: () => void;
}

export const EditModeSelectDialog = (
  props: EditModeSelectOutputDialogProps
) => {
  const intl = useIntl();
  const Dialog_Id = 'EditModeSelectDialog';

  const elements = (
    <div className="output-dialog">
      <div className="contents-box">
        <div className="input-line">
          <div className="item-group-100">
            <div className="w-45">
              <div className="border-area">
                <div className="content-wrapper">
                  <CaptionButton
                    name="aiEditBtn"
                    buttonType="basic"
                    className="button"
                    caption={GetMessage({ id: 'aiEdit', prefixId: Dialog_Id })}
                    onClick={() => {
                      props.onAIEditDecision();
                    }}
                  />
                  <p className="description-text">
                    {GetMessageWithIntl(intl, {
                      id: 'aiEditDescription',
                      prefixId: Dialog_Id,
                    })}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-10"></div>
            <div className="w-45">
              <div className="border-area">
                <div className="content-wrapper">
                  <CaptionButton
                    name="standardEditBtn"
                    buttonType="basic"
                    className="button"
                    caption={GetMessage({
                      id: 'standardEdit',
                      prefixId: Dialog_Id,
                    })}
                    onClick={() => {
                      props.onStandardEditDecision();
                    }}
                  />
                  <p className="description-text">
                    {GetMessageWithIntl(intl, {
                      id: 'standardEditDescription',
                      prefixId: Dialog_Id,
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const openModalProps: ModalDialogComponentProps = {
    cancel: () => {
      props.onCancel();
    },
    send: () => {},
    modalIsOpen: props.isOpen,
    headerLabelId: {
      id: Dialog_Id,
      prefixId: 'DIALOG_TITLE',
    },
    messageLabelId: {},
    elements,
  };

  return (
    <div className="EditModeSelectDialog">
      <ModalDialogComponent {...openModalProps} />
    </div>
  );
};
